import InboxDetailsPage from './ui/inboxDetailsPage';

export default InboxDetailsPage;
